module.exports = __webpack_public_path__ + "img/get-coupon-btn.59d67648.png";